import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable({
	providedIn: 'root',
})
export class AntilogoutGuard implements CanActivate {
	constructor(
		private authService: AuthenticationService,
		public router: Router,
	) {}

	canActivate(): boolean {
		if (!this.authService.isAuthenticated()) {
			return true;
		}
		this.router.navigate(['dashboard']);
		return false;
	}
}
